const getters = {   //实时监听state值的变化(最新状态)
  getOpenid(state) {  //方法名随意,主要是来承载变化的showFooter的值
    return state.openId
  }
};

export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js